import {tealiumConfig} from './tealiumConfig';
import {isVodacomHostname} from '@src/Hooks/useIsVodacomUser';

/**
 * Vérifie que le consentement Didomi associé au purpose Tealium est accordé.
 * Si aucun purposeId n'est défini (config), on considère que Tealium peut
 * tourner sans gating (ex. environnement de dev).
 */
export const isTealiumEnabled = (): boolean => {
  try {
    if (typeof window === 'undefined') return false;
    if (!isVodacomHostname()) return false;
    if (!tealiumConfig.account || !tealiumConfig.profile) return false;

    const purposeId = tealiumConfig.purposeId;
    if (!purposeId) return true;

    if (typeof window.Didomi === 'undefined') return false;
    const {purposes} = window.Didomi.getUserConsentStatusForAll();
    return !!purposes.enabled.length && purposes.enabled.includes(purposeId);
  } catch (err) {
    // Fail closed: any unexpected error here (e.g. a broken Didomi SDK call)
    // must never crash a caller — just treat Tealium as disabled.
    // eslint-disable-next-line no-console
    console.warn('[tealium] isTealiumEnabled check failed', err);
    return false;
  }
};
